import { render, staticRenderFns } from "./set-status.vue?vue&type=template&id=35d85b8a&scoped=true"
import script from "./set-status.vue?vue&type=script&lang=js"
export * from "./set-status.vue?vue&type=script&lang=js"
import style0 from "./set-status.vue?vue&type=style&index=0&id=35d85b8a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d85b8a",
  null
  
)

export default component.exports